import React, { useEffect, useState } from "react";
import {
  FaThLarge,
  FaUsersCog,
  FaUserPlus,
  FaRegChartBar,
  FaCog,
} from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/sidenav.css";
import $ from "jquery";
import Logout from "../auth/Logout";
import { useAsync } from "../hooks/useAsync";
import { getUserRole } from "../services/FetchAPI";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function SideMenu({
  name,
  pages,
  id,
  setcurrentPage,
  activeCurrentPage,
  activeIndexData,
  reportnameFetch,
  Embedaccess_token,
}) {
  const [pathValueData, setpathValueData] = useState("");
  const [error, setError] = useState(null);
  const [isReport, setisReport] = useState(false);
  const { ReportID } = useParams();
  const [getreportPages, setReportpage] = useState({});
  const [PageAuth, setPageAuth] = useState(true);
  const [emailData, setEmail] = useState("");
  const [userRole, setuserRole] = useState();
  const [hide, setHide] = useState(false);
  const [activeIndex, setActiveIndex] = useState(activeIndexData || 0);
  const [reportnameFetchData, setreportnameFetchData] =
    useState(reportnameFetch);

  const [isLoading, setIsLoading] = useState(false); // New state for loading
  const passtoken = !localStorage.getItem("access-token-storage") || localStorage.getItem("access-token-storage") === null
  ? null
  : JSON.parse(localStorage.getItem("access-token-storage"))["accessToken"];

  const email = localStorage.getItem("myemail");

  useEffect(() => {
    if (PageAuth) {
      // Call getUserRole(email, passtoken) only when PageAuth is true and email is not null
      getUserRole(email, passtoken)
        .then((userRoleData) => {
          // Handle the userRoleData as needed
          setuserRole(userRoleData);
        })
        .catch((error) => {
          // Handle errors here
          setuserRole();
        });
    }
  }, [PageAuth, email, passtoken]);

  localStorage.setItem("userType", userRole?.userType);
  localStorage.setItem("userGroup", userRole?.userGroup);

  const URole = userRole?.userType;

  const baseUrl = `${process.env.REACT_APP_SERVER_URL}/aipd/getMenu`;
  const fetchSearchByname = async () => {
    setIsLoading(true);
    await fetch(`${baseUrl}`, {
      headers: {
        "oidc-token": passtoken,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setReportpage(json.data);
            setError(null);
            setIsLoading(false);
          });
        }
      })
      .catch((err) => {
        setError(err.message);
        setReportpage(null);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    setTimeout(() => {
      fetchSearchByname();
    }, 100);
  }, [baseUrl, passtoken]);

  const getUrlData = () => {
    const getURl = new URL(window.location.href);

    const pathValue = getURl.pathname;
    setpathValueData(pathValue);
    if (pathValue === "/") {
      $("#MenuItmes_Overview").addClass("active");
      $(".getInfo").css("display", "none !important");
    }
    if (pathValue === "/userRegistration") {
      $("#MenuItmes_createUsers").addClass("active");
    }
    if (pathValue === "/ManageUser") {
      $("#MenuItmes_ManageUser").addClass("active");
    }
    if (pathValue === "/Settings") {
      $("#MenuItmes_Settings").addClass("active");
    }
    if (pathValue === "/ReportGenerate") {
      $("#MenuItmes_ReportGenerate").addClass("active");
    }
    if (pathValue === "/Settings") {
      $("#MenuItmes_Settings").addClass("active");
    }
    if (ReportID !== undefined) {
      $("#MenuItmes_Report").addClass("active");
    }
  };

  useEffect(() => {
    getUrlData();
  });


  const checkPath = () => {
    const getURl = new URL(window.location.href);
    // const Idfetch = url.searchParams.get("admClientId");
    const pathValue = getURl.pathname;

    if (
      pathValue === "/" ||
      pathValue === "/userRegistration" ||
      pathValue === "/ManageUser"
    ) {
      setisReport(false);
    } else {
      setisReport(true);
    }
  };

  useEffect(() => {
    checkPath();
  }, []);

  //console.log(pathValueData)
  const renderSkeleton = () => (
    <div>
      {Array(4)
        .fill()
        .map((_, i) => (
          <div key={i} style={{ marginBottom: "10px" }}>
            <Skeleton height={40} />
          </div>
        ))}
    </div>
  );

  // console.log(reportnameFetch)

  return (
    <div>
      <div id="mySidenav" className={`sideNav common_bg_color ${name}`}>
        <div className="sideNavMenu">
          <div className="sideNavMenu_grid">
            <div style={{ display: "grid", gridGap: "20px" }}>
              {isLoading ? (
                renderSkeleton()
              ) : (
                <>
                  <Link to={"/"}>
                    <div
                      id="MenuItmes_Overview"
                      style={{ gridGap: "1rem" }}
                      className="items_menu"
                    >
                      <div title="Home">
                        <DashboardIcon sx={{ fontSize: "28px" }} />
                      </div>
                      <div className="item_menuText">Home</div>
                    </div>
                  </Link>

                  {/* <Link to={"/Settings"}>
                    <div
                      id="MenuItmes_Settings"
                      style={{ gridGap: "1rem" }}
                      className="items_menu"
                    >
                      <div title="Customize visuals">
                        <DashboardCustomizeIcon sx={{ fontSize: "28px" }} />
                      </div>
                      <div className="item_menuText">Customize visuals</div>
                    </div>
                  </Link> */}

                  {URole === "Admin" && (
                    <>
                      <Link to={"/ManageUser"}>
                        <div
                          id="MenuItmes_ManageUser"
                          style={{ gridGap: "1rem" }}
                          className="items_menu"
                        >
                          <div>
                            <FaUsersCog title="User Management" fontSize={28} />
                          </div>
                          <div className="item_menuText">User Management</div>
                        </div>
                      </Link>
                    </>
                  )}

                  <div
                    id="MenuItmes_Report"
                    className="items_menu item_menuText"
                  >
                    <div
                      style={{
                        display: "flex",
                        gridGap: "15px",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <FaRegChartBar title="Reports" fontSize={28} />
                      </div>
                      <div className="item_menuText">Reports</div>
                    </div>
                  </div>

                  <div id="All_reports">
                    {getreportPages?.reports?.map((items, index) => {
                      return (
                        <div
                          id={`report_${items[0]}`}
                          key={index}
                          style={{ display: "grid" }}
                          className="items_menu"
                        >
                          <div
                            style={{
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                            className="item-flex-report"
                          >
                            <div className="item-flex-report">
                              <div style={{ display: "grid" }}>
                                <div
                                  id="reportName_id_name"
                                  className="item_menuText"
                                >
                                  <a
                                    style={{ color: "white" }}
                                    href={
                                      items[0] === 118
                                        ? `/LIMS/${items[0]}`
                                        : `/reports/${items[0]}/view`
                                    }
                                  >
                                    {items[1]}
                                  </a>
                                </div>
                              </div>
                            </div>

                            {items[0] === parseInt(id) &&
                            Embedaccess_token !== null ? (
                              <div
                                className="item_menuText getInfo"
                                id={`collapseButton_${items[0]}`}
                                onClick={() => setHide(!hide)}
                              >
                                <i
                                  style={{ cursor: "pointer" }}
                                  className={
                                    hide ? `fa fa-plus` : "fa fa-minus"
                                  }
                                ></i>
                              </div>
                            ) : (
                              <div
                                className="item_menuText getInfo"
                                id={`collapseButton_${items[0]}`}
                              >
                                <a
                                  style={{ color: "white" }}
                                  href={
                                    items[0] === 118
                                      ? `/LIMS/${items[0]}`
                                      : `/reports/${items[0]}/view`
                                  }
                                >
                                  <i
                                    style={{ cursor: "pointer" }}
                                    className="fa fa-external-link"
                                  ></i>
                                </a>
                              </div>
                            )}
                          </div>

                          {Embedaccess_token !== null && (
                            <>
                              {items[0] === parseInt(id) ? (
                                <div id="powerbi_emb_report">
                                  {!hide && (
                                    <div id="pbiPages">
                                      <div>
                                        {pages.length !== 0 ? (
                                          <>
                                            {pages &&
                                              pages.map((item, index) => {
                                                return (
                                                  <>
                                                    {item.visibility === 0 && (
                                                      <span
                                                        onClick={(e) => {
                                                          activeCurrentPage(e);
                                                          setActiveIndex(index);
                                                          setreportnameFetchData(
                                                            null
                                                          );
                                                        }}
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        key={index}
                                                        className={
                                                          reportnameFetchData !==
                                                          null
                                                            ? item.isActive ===
                                                              true
                                                              ? "item_menuText mystyle active"
                                                              : "item_menuText mystyle"
                                                            : `item_menuText mystyle ${
                                                                activeIndex ===
                                                                index
                                                                  ? "active"
                                                                  : ""
                                                              }`
                                                        }
                                                      >
                                                        <span className="tooltiptext">
                                                          {item.displayName}
                                                        </span>
                                                        {item.displayName}
                                                      </span>
                                                    )}
                                                  </>
                                                );
                                              })}
                                          </>
                                        ) : (
                                          <>
                                            {Array(2)
                                              .fill()
                                              .map((_, i) => (
                                                <div
                                                  key={i}
                                                  style={{
                                                    marginBottom: "0px",
                                                  }}
                                                >
                                                  <Skeleton height={30} />
                                                </div>
                                              ))}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>

            <>
              <Logout />
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
